export default "__VITE_ASSET__C7kFp44a__"